// only uncomment that are needed
// all plans are kept for future reference

export const PLAN_MAPS = {
  // AI_ADVANCE_REPORT_AI_ADVANCE_CALL_REPORT_VIEW: 'ai-advance-report.ai-advance-call-report.view',
  // AI_ADVANCE_REPORT_TRANSCRIPTION_INFORMATION_VIEW: 'ai-advance-report.transcription-information.view',
  // AI_DASHBOARD_AI_DASHBOARD_COUNT_VIEW: 'ai-dashboard.ai-dashboard-count.view',
  // AI_DASHBOARD_AI_DASHBOARD_INTENT_VIEW: 'ai-dashboard.ai-dashboard-intent.view',
  // AI_DASHBOARD_AI_GRAPH_REPORT_VIEW: 'ai-dashboard.ai-graph-report.view',
  AI_DASHBOARD_AI_REPORT_ANALYTICS_VIEW: 'ai-dashboard.ai-report-analytics.view',
  // AI_SENTIMENT_AI_MEMBER_PERFORMANCE_VIEW: 'ai-sentiment.ai-member-performance.view',
  // ASSIGN_CHANNELS_RECENT_MESSAGE_CONVERSATIONS_SEND_INTERNAL_MESSAGE:
  //   'assign-channels.recent-message-conversations.send-internal-message',
  // DASHBOARD_CALL_HISTORIES_VIEW: 'dashboard.call-histories.view',
  DASHBOARD_LIVE_CALLS_VIEW: 'dashboard.live-calls.view',
  // DIALER_CALL_RECORD_CALL_RECORD: 'dialer.call-record.call-record',
  // DIALER_CALL_TRANSFER_CALL_TRANSFER: 'dialer.call-transfer.call-transfer',
  // MEMBER_REPORT_INDIVIDUAL_DASHBOARD_REPORT_VIEW: 'member-report.individual-dashboard-report.view',
  // MEMBER_REPORT_MEMBER_DASHBOARD_REPORT_VIEW: 'member-report.member-dashboard-report.view',
  // NUMBER_REPORT_DASHBOARD_NUMBER_ANALYTIC_VIEW: 'number-report.dashboard-number-analytic.view',
  // NUMBER_REPORT_DASHBOARD_REPORT_ANALYTIC_VIEW: 'number-report.dashboard-report-analytic.view',
  // NUMBER_REPORT_INDIVIDUAL_NUMBER_REPORT_VIEW: 'number-report.individual-number-report.view',
  // NUMBER_REPORT_NUMBER_AGGREGATED_REPORT_VIEW: 'number-report.number-aggregated-report.view',
  // NUMBER_REPORT_NUMBER_GRAPH_REPORT_VIEW: 'number-report.number-graph-report.view',
  POWER_DIALER_POWER_CAMPAIGN_CALL_HISTORY_EXPORT: 'power-dialer.power-campaign-call-history.export',
  POWER_DIALER_POWER_CAMPAIGN_CALL_HISTORY_VIEW: 'power-dialer.power-campaign-call-history.view',
  POWER_DIALER_POWER_CAMPAIGN_CREATE: 'power-dialer.power-campaign.create',
  POWER_DIALER_POWER_CAMPAIGN_DELETE: 'power-dialer.power-campaign.delete',
  POWER_DIALER_POWER_CAMPAIGN_LIST: 'power-dialer.power-campaign.list',
  POWER_DIALER_POWER_CAMPAIGN_UPDATE: 'power-dialer.power-campaign.update',
  POWER_DIALER_POWER_CAMPAIGN_UPDATE_CAMPAIGN_CONTACT: 'power-dialer.power-campaign.update-campaign-contact',
  POWER_DIALER_POWER_CAMPAIGN_VIEW: 'power-dialer.power-campaign.view',
  POWER_DIALER_POWER_DIALER_ACTIVE_SESSION_VIEW: 'power-dialer.power-dialer-active-session.view',
  POWER_DIALER_POWER_DISPOSITION_CREATE: 'power-dialer.power-disposition.create',
  POWER_DIALER_POWER_DISPOSITION_DELETE: 'power-dialer.power-disposition.delete',
  POWER_DIALER_POWER_DISPOSITION_DISPOSITION_CONTACTS: 'power-dialer.power-disposition.disposition-contacts',
  POWER_DIALER_POWER_DISPOSITION_LIST: 'power-dialer.power-disposition.list',
  POWER_DIALER_POWER_DISPOSITION_UPDATE: 'power-dialer.power-disposition.update',
  POWER_DIALER_POWER_DISPOSITION_UPDATE_POWER_CONTACT: 'power-dialer.power-disposition.update-power-contact',
  POWER_DIALER_POWER_DISPOSITION_VIEW: 'power-dialer.power-disposition.view',
  POWER_DIALER_POWER_IMPORT_LISTS_CREATE: 'power-dialer.power-import-lists.create',
  POWER_DIALER_POWER_IMPORT_LISTS_DELETE: 'power-dialer.power-import-lists.delete',
  POWER_DIALER_POWER_IMPORT_LISTS_VIEW: 'power-dialer.power-import-lists.view',
  SETTINGS_CALLER_ID_DELETE: 'settings.caller-id.delete',
  SETTINGS_CALLER_ID_LIST: 'settings.caller-id.list',
  SETTINGS_CALLER_ID_VERIFY: 'settings.caller-id.verify',
  // SETTINGS_CALLER_ID_VIEW: 'settings.caller-id.view',
  SETTINGS_MEMBERS_INVITE_MEMBERS: 'settings.members.invite-members',
  SETTINGS_NUMBER_SETTING_AUTO_RECORD: 'settings.number-setting.auto-recording',
  // SETTINGS_MY_NUMBER_TOGGLE: 'settings.my-number.toggle',
  // SETTINGS_MY_NUMBER_VIEW: 'settings.my-number.view',
  // SETTINGS_MY_NUMBERS_ALWAYS_FORWARD_TO_EXTERNAL_NUMBER: 'settings.my-numbers.always-forward-to-external-number',
  SETTINGS_MY_NUMBERS_CALL_TRANSFER_SETTING: 'settings.my-numbers.call-transfer-setting',
  // SETTINGS_MY_NUMBERS_FORWARD_TO_EXTERNAL_NUMBER_IF_UNANSWERED:
  //   'settings.my-numbers.forward-to-external-number-if-unanswered',
  // SETTINGS_MY_NUMBERS_INTERACTIVE_VOICE_RESPONSE: 'settings.my-numbers.interactive-voice-response',
  SETTINGS_NUMBER_SETTING_AUTO_TRANSCRIBE: 'settings.number-setting.auto-transcribe',
  // SETTINGS_NUMBER_SETTING_CREATE_BUSINESS_HOURS: 'settings.number-setting.create-business-hours',
  SETTINGS_NUMBER_SETTING_CREATE_SAVE_REPLIES: 'settings.number-setting.create-save-replies',
  SETTINGS_NUMBER_SETTING_DELETE_SAVE_REPLIES: 'settings.number-setting.delete-save-replies',
  // SETTINGS_NUMBER_SETTING_ENABLE_VOICE_MAIL_EMAIL: 'settings.number-setting.enable-voice-mail-email',
  // SETTINGS_NUMBER_SETTING_RECORDING: 'settings.number-setting.recording',
  SETTINGS_NUMBER_SETTING_UPDATE_SAVE_REPLIES: 'settings.number-setting.update-save-replies',
  SETTINGS_NUMBER_SETTING_VIEW_SAVE_REPLIES: 'settings.number-setting.view-save-replies',
  // SETTINGS_NUMBER_SETTING_VOICEMAIL: 'settings.number-setting.voicemail',
  // SETTINGS_NUMBER_SETTING_WELCOME_MESSAGE: 'settings.number-setting.welcome-message',
  TEAMS_TEAMS_CREATE: 'teams.teams.create',
  TEAMS_TEAMS_DELETE: 'teams.teams.delete',
  TEAMS_TEAMS_LIST: 'teams.teams.list',
  TEAMS_TEAMS_UPDATE: 'teams.teams.update',
  TEAMS_TEAMS_VIEW: 'teams.teams.view',

  // settings
  SETTINGS_NUMBER_SETTING_VIEW_BUSINESS_HOURS: 'settings.number-setting.view-business-hours',
  SETTINGS_NUMBER_SETTING_VIEW_CALL_TRANSFER: 'settings.call-flows.call-transfer',
  SETTINGS_NUMBER_SETTING_VIEW_IVR: 'settings.call-flows.interactive-voice-response',
} as const;
